exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-progress-bar-item.progress-bar {\n  font-size: inherit;\n  line-height: 1.5em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/progress-bar-item.less
// module id = 252
// module chunks = 0